<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'HubExpertRessources'
});
</script>
<template>
  <ka-container
    code="ressources-expert"
    :data="page.$info.ressourcesExpert">
    <!-- Container de page -->
    <ka-container code="container-de-page">
      <PageFixeEntete
        instance-class="page-fixe-entete--p42"
        text-1="Sur cette page vous trouverez plusieurs ressources pour prendre en main les outils Matchers et anticiper les différentes étapes d’une formation. Transmettre son savoir c’est avant tout l’organiser !<br> <br><strong>Matchers vous accompagne</strong> dans les démarches administratives relatives à une activité d'auto-entrepreneur à travers des tutoriels. Pour vous aider à faire de la formation une nouvelle compétence, nous vous partagerons aussi toutes les astuces et les conseils de notre équipe et de notre communauté d’experts." />
      <!-- Container ressources -->
      <ka-container code="container-ressources">
        <!-- Titres -->
        <ka-container code="titres">
          <ka-text code="toutes-les-ressources">
            <span v-html="t('ressourcesExpert.containerDePage.containerRessources.titres.toutesLesRessources.value', `<strong>Toutes les ressources</strong>`)" />
          </ka-text>
          <ka-text
            code="formation"
            :options="{ hidden: null }">
            <span v-html="t('ressourcesExpert.containerDePage.containerRessources.titres.formation.value', `Formation`)" />
          </ka-text>
          <ka-text
            code="recrutement"
            :options="{ hidden: null }">
            <span v-html="t('ressourcesExpert.containerDePage.containerRessources.titres.recrutement.value', `Recrutement`)" />
          </ka-text>
          <ka-text
            code="demarches-rh"
            :options="{ hidden: null }">
            <span v-html="t('ressourcesExpert.containerDePage.containerRessources.titres.demarchesRh.value', `Démarches RH`)" />
          </ka-text>
          <!-- Container -->
          <ka-container code="container" />
        </ka-container>
        <!-- Ressources -->
        <ka-container code="ressources">
          <!-- Ressource1 -->
          <ka-container
            code="ressource-1"
            :options="{
              href: { name: `hub-expert-Ressources-preparer-rdv-decouverte` },
              click: page.ressource1Click
            }">
            <ka-image
              code="image"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                alt: `Assurez un premier échange de qualité avec l'entreprise que vous allez former en vous préparant au rendez-vous découverte`
              }"
              value="https://ucarecdn.com/e038e765-696c-406b-8cb6-39376121c446/" />
            <ka-text code="preparer-mon-1-er-rendez-vous">
              <h2 v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource1.preparerMon1ErRendezVous.value', `Préparer mon 1er<strong> rendez-vous découverte</strong>`)" />
            </ka-text>
            <ka-text code="il-sagit-dun-premier">
              <span v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource1.ilSagitDunPremier.value', `Il s’agit d’un premier échange pour en savoir plus sur vos compétences. Au stade de l’entretien découverte, les contours de la formation...`)" />
            </ka-text>
            <!-- Container -->
            <ka-container code="container-1">
              <ka-button
                code="indication"
                :options="{ ripple: true }">
                <span v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource1.container1.indication.value', `Guide - Formation Matchers`)" />
              </ka-button>
            </ka-container>
            <ka-text
              code="consulter-gt"
              :options="{
                href: { name: `hub-expert-Ressources-preparer-rdv-decouverte` },
                click: page.consulterGtClick
              }">
              <span v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource1.consulterGt.value', `Consulter >`)" />
            </ka-text>
          </ka-container>
          <!-- Ressource 2 -->
          <ka-container
            code="ressource-2"
            :options="{
              href: { name: `hub-expert-Ressources-rediger-programme-de-formation` },
              click: page.ressource2Click
            }">
            <ka-image
              code="image-1"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                alt: `Créez un programme de formation adapté à l'entreprise et basé sur vos connaissances `
              }"
              value="https://ucarecdn.com/d94a0c66-9322-47b8-afc4-5d0d564e6da8/" />
            <ka-text code="comment-rediger-un">
              <h2 v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource2.commentRedigerUn.value', `Comment rédiger un <strong>programme de formation ?</strong>`)" />
            </ka-text>
            <ka-text code="dapres-les-templates">
              <span v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource2.dapresLesTemplates.value', `D’après les templates délivrés par Matchers, l’expert est chargé d’adapter le programme de formation pour qu’il soit en accord avec les objectifs...`)" />
            </ka-text>
            <!-- Container -->
            <ka-container code="container-2">
              <ka-button
                code="button-1"
                :options="{ ripple: true }">
                <span v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource2.container2.button1.value', `Guide - Formation Matchers`)" />
              </ka-button>
            </ka-container>
            <ka-text
              code="text-1"
              :options="{
                href: { name: `hub-expert-Ressources-rediger-programme-de-formation` },
                click: page.text1Click
              }">
              <span v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource2.text1.value', `Consulter >`)" />
            </ka-text>
          </ka-container>
          <!-- Ressource 3 -->
          <ka-container
            code="ressource-3"
            :options="{
              href: { name: `hub-expert-Ressources-construire-support-de-formation` },
              click: page.ressource3Click
            }">
            <ka-image
              code="image-2"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                alt: `Pour assurer une formation qualitative, utilisez nos ressources et établissez un support de formation adapté`
              }"
              value="https://ucarecdn.com/046ec7f1-2204-41f0-a4de-c8ffe03b961c/" />
            <ka-text code="comment-creer-mon">
              <h2 v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource3.commentCreerMon.value', `Comment créer mon<strong> support de formation ?</strong>`)" />
            </ka-text>
            <ka-text code="le-temps-que-vous-y">
              <span v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource3.leTempsQueVousY.value', `Le temps que vous y passerez sera du temps CA-PI-TA-LI-SÉ. Bien préparer votre première formation vous permettra d’en réutiliser le contenu pour vos prochaines...`)" />
            </ka-text>
            <!-- Container -->
            <ka-container code="container-3">
              <ka-button
                code="button-2"
                :options="{ ripple: true }">
                <span v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource3.container3.button2.value', `Guide - Formation Matchers`)" />
              </ka-button>
            </ka-container>
            <ka-text
              code="text-2"
              :options="{
                href: { name: `hub-expert-Ressources-construire-support-de-formation` },
                click: page.text2Click
              }">
              <span v-html="t('ressourcesExpert.containerDePage.containerRessources.ressources.ressource3.text2.value', `Consulter >`)" />
            </ka-text>
          </ka-container>
          <BlocPreviewRessourceHubRessources
            instance-class="bloc-preview-ressource-hub-ressources--p42"
            :options="{
              href: { name: `Expert-Ressources-organiser-sa-formation` },
              click: page.blocPreviewRessourceHubRessourcesClick,
              hidden: false
            }"
            creer-mon-auto-entreprise="<strong>Comment bien organiser sa formation ?</strong>"
            lorem-ipsum-dolor-sit="Découvrez la plus grande qualité pour réussir une formation Matchers ou encore nos 8 conseils pour préparer sa première session de formation."
            indication="Guide - Formation Matchers"
            picture="https://images.unsplash.com/photo-1616530834117-9167fb0d8ebc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxOXx8Y2FsZW5kYXJ8ZW58MHx8fHwxNjkyODAwMTMzfDA&ixlib=rb-4.0.3&q=80&w=1080" />
          <BlocPreviewRessourceHubRessources
            instance-class="element-1--p42"
            :options="{
              href: { name: `Expert-Ressources-animer-la-formation` },
              click: page.element1Click,
              hidden: false
            }"
            creer-mon-auto-entreprise="<strong>Animer la formation</strong>"
            lorem-ipsum-dolor-sit="Outillage pour animer les sessions et temps fors de la formation, découvrez les clés pour rythmer vos échanges avec les apprenants. "
            indication="Guide - Formation Matchers"
            picture="https://images.unsplash.com/photo-1612831455359-970e23a1e4e9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw5fHxwciVDMyVBOXNlbnRhdGlvbnxlbnwwfHx8fDE2OTIyNjA3OTJ8MA&ixlib=rb-4.0.3&q=80&w=1080" />
          <BlocPreviewRessourceHubRessources
            instance-class="element-3--p42"
            :options="{
              href: { name: `Expert-Ressources-Evaluations` },
              click: page.element3Click,
              hidden: false
            }"
            creer-mon-auto-entreprise="<strong>Évaluer les apprentissages</strong>"
            lorem-ipsum-dolor-sit="Fin de formation = évaluations. Chez Matchers il y a deux types d'évaluations. Une pour la pratique et l'autre pour la théorie. "
            indication="Guide - Formation Matchers"
            picture="https://images.unsplash.com/photo-1518349619113-03114f06ac3a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwzMHx8dGVzdHxlbnwwfHx8fDE2OTIyODY5NjR8MA&ixlib=rb-4.0.3&q=80&w=1080" />
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { hubExpertRessources } from './store'
import BlocPreviewRessourceHubRessources from '~/components/BlocPreviewRessourceHubRessources/index.vue'
import PageFixeEntete from '~/components/PageFixeEntete/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p42')
const appData = appDataStore()
const page = hubExpertRessources()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
